"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIpFamily = exports.checkSession = exports.startSession = exports.getAnalysis = exports.AnalysisSeverity = exports.constants = exports.MAX_FILE_SIZE = exports.emitter = exports.extendAnalysis = exports.createBundleWithCustomFiles = exports.createBundleFromFolders = exports.getSupportedFiles = exports.analyzeScmProject = exports.analyzeFolders = exports.getGlobPatterns = void 0;
const analysis_1 = require("./analysis");
Object.defineProperty(exports, "analyzeFolders", { enumerable: true, get: function () { return analysis_1.analyzeFolders; } });
Object.defineProperty(exports, "extendAnalysis", { enumerable: true, get: function () { return analysis_1.extendAnalysis; } });
Object.defineProperty(exports, "analyzeScmProject", { enumerable: true, get: function () { return analysis_1.analyzeScmProject; } });
const bundles_1 = require("./bundles");
Object.defineProperty(exports, "getSupportedFiles", { enumerable: true, get: function () { return bundles_1.getSupportedFiles; } });
Object.defineProperty(exports, "createBundleFromFolders", { enumerable: true, get: function () { return bundles_1.createBundleFromFolders; } });
Object.defineProperty(exports, "createBundleWithCustomFiles", { enumerable: true, get: function () { return bundles_1.createBundleWithCustomFiles; } });
const emitter_1 = require("./emitter");
Object.defineProperty(exports, "emitter", { enumerable: true, get: function () { return emitter_1.emitter; } });
const http_1 = require("./http");
Object.defineProperty(exports, "startSession", { enumerable: true, get: function () { return http_1.startSession; } });
Object.defineProperty(exports, "checkSession", { enumerable: true, get: function () { return http_1.checkSession; } });
Object.defineProperty(exports, "getAnalysis", { enumerable: true, get: function () { return http_1.getAnalysis; } });
Object.defineProperty(exports, "getIpFamily", { enumerable: true, get: function () { return http_1.getIpFamily; } });
const constants_1 = require("./constants");
Object.defineProperty(exports, "MAX_FILE_SIZE", { enumerable: true, get: function () { return constants_1.MAX_FILE_SIZE; } });
const constants = __importStar(require("./constants"));
exports.constants = constants;
const files_1 = require("./files");
Object.defineProperty(exports, "getGlobPatterns", { enumerable: true, get: function () { return files_1.getGlobPatterns; } });
const analysis_options_interface_1 = require("./interfaces/analysis-options.interface");
Object.defineProperty(exports, "AnalysisSeverity", { enumerable: true, get: function () { return analysis_options_interface_1.AnalysisSeverity; } });
//# sourceMappingURL=index.js.map